/** * 头部用户信息 */
<template>
  <div class="navcon">
    <!-- <button
      type="button"
      class="navcon-action"
      title="全屏"
      @click="toggleFullscreen"
    >
      <i class="el-icon-full-screen"></i>
    </button> -->
    <el-popover
      placement="bottom-end"
      width="120"
      trigger="hover"
      popper-class="navcon-pop"
    >
      <el-button plain round size="small"
        type="text"
        style="margin: 0 auto;display: block;"
        @click="openProfile"
        >个人中心</el-button
      >
      <el-button plain round size="small"
        type="text"
        style="margin: 8px auto 0;display: block;"
        @click="exit()"
        >退出</el-button
      >
      <div class="navcon-title" slot="reference">
        <div class="navcon-flag">
          <img :src="avatarUrl" alt="" />
        </div>
        <div class="navcon-name">{{ displayName }}</div>
        <img class="navcon-arrow" :src="arrowImg" alt="" />
      </div>
    </el-popover>
    <ProfileCenter ref="profileRef" @profile-loaded="onProfileLoaded" />
  </div>
</template>
<script>
import ProfileCenter from "./ProfileCenter.vue";
import {
  getUserInfo,
  setUserInfo,
  fetchAndSaveUserInfo
} from "@/utils/userInfo";
import { ensureDictCache } from "@/utils/dict";
import { logoutCurrentUser } from "@/utils/authLogout";
import { getToken } from "@/utils/token";
import settings from "@/settings";

const defaultAvatar = require("@/assets/img/home/avatar-admin.png");

export default {
  name: "navcon",
  components: {
    ProfileCenter
  },
  data() {
    return {
      collapsed: true,
      displayName: "管理员",
      avatarUrl: defaultAvatar,
      bellImg: require("@/assets/img/home/icon-bell.png"),
      arrowImg: require("@/assets/img/home/icon-arrow-down.png")
    };
  },
  created() {
    const userInfo = getUserInfo();
    if (userInfo) {
      this.syncDisplayName();
    } else if (getToken()) {
      this.loadDisplayName();
      ensureDictCache();
    }
  },
  methods: {
    syncDisplayName() {
      const userInfo = getUserInfo();
      if (userInfo) {
        this.displayName =
          userInfo.nickName ||
          userInfo.teacherName ||
          userInfo.userName ||
          "教师";
        this.avatarUrl = userInfo.avatar || defaultAvatar;
      }
    },
    async loadDisplayName() {
      if (!getToken()) return;
      try {
        const data = await fetchAndSaveUserInfo();
        this.$store.commit("login", data);
        this.displayName =
          data.nickName ||
          data.teacherName ||
          data.userName ||
          "教师";
        this.avatarUrl = data.avatar || defaultAvatar;
        this.$root.Bus.$emit("user-info-updated");
      } catch (e) {}
    },
    onProfileLoaded(data) {
      const cached = getUserInfo() || {};
      const merged = { ...cached, ...data };
      setUserInfo(merged);
      this.$store.commit("login", merged);
      this.displayName =
        merged.nickName ||
        merged.teacherName ||
        merged.userName ||
        this.displayName;
      this.avatarUrl = merged.avatar || defaultAvatar;
    },
    openProfile() {
      this.$refs.profileRef.open();
    },
    toggleFullscreen() {
      const doc = document;
      if (!doc.fullscreenElement) {
        doc.documentElement.requestFullscreen &&
          doc.documentElement.requestFullscreen();
      } else if (doc.exitFullscreen) {
        doc.exitFullscreen();
      }
    },
    exit() {
      this.$confirm("退出登录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          try {
            await logoutCurrentUser();
          } catch (e) {}
          this.$store.commit("logout");
          this.$router.push({ path: "/login" });
          this.$message({
            type: "success",
            message: "已退出登录!"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    toggle(showtype) {
      this.collapsed = !showtype;
      this.$root.Bus.$emit("toggle", this.collapsed);
    }
  }
};
</script>
<style scoped lang="less">
.navcon {
  display: flex;
  align-items: center;
  gap: 8px;
}

.navcon-action {
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: #4e5969;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  padding: 0;

  &__img {
    width: 36px;
    height: 36px;
    display: block;
  }

  &:hover {
    color: #1c68ff;
  }
}

.navcon-title {
  color: #1d2129;
  font-size: 14px;
  height: 34px;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 0 12px;
  gap: 8px;
  border-radius: 20px;
  transition: background 0.2s;
  background: rgba(255, 255, 255, 0.6);
  box-shadow: 0px 2px 12px 0px rgba(99, 162, 241, 0.15);

  &:hover {
    background: rgba(99, 162, 241, 0.15);
  }
}

.navcon-flag {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-right: 10px;
  overflow: hidden;
  flex-shrink: 0;
  background: #e8eef8;
  border: 2px solid #fff;
  box-shadow: 0 1px 4px rgba(15, 35, 95, 0.12);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
}

.navcon-name {
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
  font-size: 14px;
  color: rgba(56, 107, 202, 1);
}

.navcon-arrow {
  margin-left: 6px;
  width: 12px;
  height: 12px;
  display: block;
  opacity: 0.7;
}
</style>
<style>
.navcon-pop {
  padding: 8px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Layout/navcon.vue